import { render } from "./SeleccionEnviosPage.vue?vue&type=template&id=29b45384&scoped=true"
import script from "./SeleccionEnviosPage.vue?vue&type=script&lang=js"
export * from "./SeleccionEnviosPage.vue?vue&type=script&lang=js"

import "./SeleccionEnviosPage.vue?vue&type=style&index=0&id=29b45384&scoped=true&lang=scss"

import exportComponent from "C:\\GIT CLONADO\\ubiku.2023\\com.ubiku.ges.ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29b45384"]])

export default __exports__